import React, { useEffect, useState } from "react";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { zeroRemover } from "../../utils/dateformatter";
import {
  mapEventInfoToGroups,
  microAllocations,
  microCustomAllocations,
  microgridData,
  renderGroups,
  townAllocations,
  townHallData,
} from "./equipGroup";

const EquipmentViewModal = ({
  isOpen,
  toggle,
  data,
  modalPos,
  arrowTop,
  source,
  eventColorMap,
  activeColors,
}) => {
  const isFromCalendar = source === "customCalendar";
  const isMultipleData =
    isFromCalendar && Array.isArray(data) && data.length > 1;

  const [activeEventId, setActiveEventId] = useState(data?.[0]?.event_id);
  // const [arrowTop, setArrowTop] = useState(null);
  // const [arrowColor, setArrowColor] = useState("#fff");

  const [eventOrder, setEventOrder] = useState(
    Array.isArray(data) ? [...data] : [],
  );

  const handleColorClick = (eventId) => {
    setActiveEventId(eventId);

    setEventOrder((prev) => {
      const idx = prev.findIndex((e) => e.event_id === eventId);
      if (idx <= 0) return prev; // already first
      const newOrder = [...prev];
      const [clicked] = newOrder.splice(idx, 1);
      newOrder.unshift(clicked); // move clicked to first
      return newOrder;
    });
  };

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      setActiveEventId(data[0].event_id);
    }
  }, [data]);

  const activeEvent = Array.isArray(data)
    ? data.find((e) => e.event_id === activeEventId)
    : data;

  const [microGroups, setMicroGroups] = useState(() =>
    mapEventInfoToGroups(microgridData, data?.event_info?.microgrid || {}),
  );

  const [townGroups, setTownGroups] = useState(() =>
    mapEventInfoToGroups(townHallData, data?.event_info?.yakuba || {}),
  );

  useEffect(() => {
    if (activeEvent?.event_info) {
      setMicroGroups(
        mapEventInfoToGroups(
          microgridData,
          activeEvent.event_info.microgrid || {},
        ),
      );

      setTownGroups(
        mapEventInfoToGroups(townHallData, activeEvent.event_info.yakuba || {}),
      );
    }
  }, [activeEvent]);

  useEffect(() => {
    if (Array.isArray(data)) setEventOrder([...data]);
  }, [data]);

  const getArrowTop = () => {
    if (source === "customCalendar") {
      return arrowTop - 45;
    } else if (isMultipleData) {
      return arrowTop - 32;
    } else {
      return arrowTop - 55;
    }
  };
  const activeColor =
    eventColorMap && activeEventId ? eventColorMap[activeEventId] || "" : ""; // fallback black

  const resolvedActiveColor = activeColors || activeColor || "#000";
  // useEffect(() => {
  //   if (!isOpen) return;

  //   const top = getArrowTop();
  //   setArrowTop(top); // passed from props
  // }, [isOpen, source, isMultipleData]);

  return (
    <Modal
      centered
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      className={`equipmentModal equipmentViewModal ${
        isMultipleData ? "noRadius" : ""
      }`}
      style={{
        // border: `7px solid ${activeColors}`,
        // borderRadius: "9px",
        position: !isFromCalendar ? "absolute" : undefined,
        left: !isFromCalendar ? modalPos?.left : undefined,
        "--arrow-top": !isFromCalendar ? `${getArrowTop()}px` : undefined,
      }}
    >
      {isMultipleData && (
        <>
          <Row
            className="firstHead"
            style={{
              // position: "absolute",
              top: 0, // or wherever you want it inside the modal
              left: 0,
              width: "100%", // full modal width
              display: "flex",
              margin: 0,
              padding: 0,
              zIndex: 10,
            }}
          >
            {eventOrder.map((ev, i) => {
              const isActive = ev.event_id === activeEventId;
              return (
                <div
                  key={ev.event_id}
                  className={`colorCol ${isActive ? "active" : ""}`}
                  style={{
                    cursor: "pointer",
                    height: "16px",
                    flex: isActive ? 6 : 3,
                    backgroundColor: eventColorMap[ev.event_id],
                    borderTopLeftRadius: i === 0 ? "9px" : undefined,
                    borderTopRightRadius:
                      i === eventOrder.length - 1 ? "9px" : undefined,
                  }}
                  onClick={() => handleColorClick(ev.event_id)}
                />
              );
            })}
          </Row>

          <Row
            className="secondHead"
            style={{
              backgroundColor: eventColorMap[activeEventId],
            }}
          />
        </>
      )}

      <ModalBody className="pt-0" style={{ padding: "0" }}>
        <div
          style={{
            // border: `1px solid ${resolvedActiveColor}`, // inner border
            backgroundColor: activeColor, // fill entire inner box
            borderRadius: isMultipleData ? "0px" : "9px", // optional rounded corners
            padding: isMultipleData
              ? "5px 12px 12px 12px"
              : "12px 12px 12px 12px",
            // padding: "12px", // inner spacing for content
            color: "#fff", // text color so it’s readable
          }}
        >
          {/* イベント日時 */}
          <Row className="allRow mb-2">
            <Col xs={3}>
              <label className="label">１. イベント日時</label>
            </Col>
            <Col xs={7} className="d-flex px-0">
              <Row>
                <span className="midDate">
                  {zeroRemover(activeEvent?.start_time)}
                </span>
              </Row>
              <span className="midDate">~</span>
              <Row>
                <span className="midDate">
                  {zeroRemover(activeEvent?.end_time)}
                </span>
              </Row>
            </Col>
          </Row>

          {/* イベント名 */}
          <Row className="allRow mb-2">
            <Col xs={3}>
              <label className="label">2. イベント名</label>
            </Col>
            <Col xs={7}>
              <span className="midDate">{activeEvent?.title}</span>
            </Col>
          </Row>

          {/* イベント詳細 */}
          <Row className="allRow mb-2">
            <Col xs={3}>
              <label className="label">3. イベント詳細</label>
            </Col>
            <Col xs={7}>
              <span className="midDate">{activeEvent?.description}</span>
            </Col>
          </Row>

          {/* イベント設定 */}
          <Row className="allRow">
            <Row className="d-flex justify-content-between px-0 mx-0">
              <Col>
                <label className="label">４. イベント設定</label>
              </Col>
            </Row>

            <div className="settingCont">
              <div className="headerRow mt-1">
                <span>釧路マイクログリッド</span>
              </div>
              {renderGroups(
                microGroups,
                setMicroGroups,
                microAllocations,
                microCustomAllocations,
                true,
              )}

              <div className="headerRow mt-1">
                <span>釧路役場</span>
              </div>
              {renderGroups(
                townGroups,
                setTownGroups,
                townAllocations,
                {},
                true,
              )}
            </div>
          </Row>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default EquipmentViewModal;
